import { decamelizeKeys } from 'humps';

import { Configs } from '~/features/admin/types';
import { pilot } from '~/services/serviceInstances';

type GetClientsParams = {
  configs: Configs;
};

// Pilot axios returns response.data as-is (no camelize). Create 201 may include
// `clm_r2_targeting` with snake_case keys.
export type ClmR2Targeting = {
  flag_keys?: string[];
  failed_flag_keys?: string[];
  segment_error?: boolean | null;
  skipped?: boolean;
};

export type CreateClientResponse = {
  clm_r2_targeting?: ClmR2Targeting;
};

export const createClient = async ({
  configs,
}: GetClientsParams): Promise<CreateClientResponse> => {
  const params = decamelizeKeys(configs);

  return pilot.post('/client/', params, { timeout: 180_000 });
};
